
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1qprf_160mh_5"
};
  